import values from 'lodash/fp/values';

export const getValueFromDataObject = (data, valueName) => {
  return values(data).map((item) =>
    Array.isArray(item) ? item.map((val) => val[valueName]) : item[valueName]
  );
};
